export class HttpError extends Error {
	statusCode: number
	statusText: string

	constructor(statusCode: number, statusText: string) {
		super(statusText)
		this.statusCode = statusCode
		this.statusText = statusText
		Object.setPrototypeOf(this, HttpError.prototype)
	}
}

type RestRequestParams = unknown
type RestLoadingStopper = () => void
type RestStartLoading = () => RestLoadingStopper
type FastApiJsonEnvelope = {
	body: string
}

const noopStopLoading = () => undefined

// FIXME: 雑すぎるのでなんとかしたい
// FIXME: host を optional 引数になってるの修正、params 型つける
// FIXME: なぜか parseJson というのが必要なのと必要じゃないやつがあるので、片方だけにしたい (現状 fastAPI と go で異なっている)
// FIXME: なぜか404とかでもTypeErrorがかえり、status codeをみれないことがある (fastAPI の方?)

const apiService = {
	sendRequest: async <TResponse = any>(
		method: string,
		endpoint: string,
		params: RestRequestParams,
		parseJson: boolean,
		startLoading?: RestStartLoading, // this arg can be deleted if you make a provider for managing rest requests
		host?: string
	): Promise<TResponse> => {
		let stopLoading: RestLoadingStopper = noopStopLoading
		if (startLoading) {
			stopLoading = startLoading()
		}

		try {
			let body: BodyInit | null | undefined = undefined
			if (params) {
				body = JSON.stringify(params)
			}
			const res = await fetch(`${host}${endpoint}`, {
				method: method,
				headers: {
					"Content-Type": "application/json",
				},
				body: body,
			})
			// network errorの場合はここに来る前にthrowされるらしい
			// https://zenn.dev/junki555/articles/4ab67fc78ce64c
			if (!res.ok) {
				throw new HttpError(res.status, res.statusText)
			}
			const resJson: unknown = await res.json()
			console.log("resJson", resJson)
			if (parseJson) {
				return JSON.parse((resJson as FastApiJsonEnvelope).body) as TResponse
			}
			return resJson as TResponse
		} catch (error) {
			console.log("error", error)
			throw error
		} finally {
			stopLoading()
		}
	},

	get: async <TResponse = any>(
		endpoint: string,
		startLoading?: RestStartLoading,
		host: string | undefined = process.env.REACT_APP_CANCY_PUBLIC_API_URL,
		parseJson = true
	): Promise<TResponse> => {
		return await apiService.sendRequest<TResponse>(
			"GET",
			endpoint,
			undefined,
			parseJson,
			startLoading,
			host
		)
	},

	post: async <TResponse = any>(
		endpoint: string,
		params: RestRequestParams,
		startLoading?: RestStartLoading,
		host: string | undefined = process.env.REACT_APP_CANCY_PUBLIC_API_URL,
		parseJson = true
	): Promise<TResponse> => {
		return await apiService.sendRequest<TResponse>(
			"POST",
			endpoint,
			params,
			parseJson,
			startLoading,
			host
		)
	},

	put: async <TResponse = any>(
		endpoint: string,
		params: RestRequestParams,
		startLoading?: RestStartLoading,
		host: string | undefined = process.env.REACT_APP_CANCY_PUBLIC_API_URL,
		parseJson = true
	): Promise<TResponse> => {
		return await apiService.sendRequest<TResponse>(
			"PUT",
			endpoint,
			params,
			parseJson,
			startLoading,
			host
		)
	},
}

export default apiService
